<template>
	<div class="setting_ps px-7 py-4 overflow-y-auto">
		<div class="width-100 height-100 display-flex flex-column">
			<div class="display-flex flex-row flex-justify-space-between mb-12">
				<ManageAppsHeaderExplanations />
				<ManageAppsSelectFavoriteMenu />
			</div>
			<ManageAppsFavoriteAppsList class="pb-4" />
		</div>
	</div>
</template>
<script>
import ManageAppsFavoriteAppsList from '@/views/settings/ManageApps/ManageAppsFavoriteAppsList.vue';
import ManageAppsHeaderExplanations from '@/views/settings/ManageApps/ManageAppsHeaderExplanations.vue';
import ManageAppsSelectFavoriteMenu from '@/views/settings/ManageApps/ManageAppsSelectFavoriteMenu.vue';
import { getAllDirectoryApps } from '@/store/modules/apps/actions';
import { mapActionsShorthand } from '@/store/utils/mappers';
export default {
	name: 'SettingsManageApps',
	components: { ManageAppsFavoriteAppsList, ManageAppsSelectFavoriteMenu, ManageAppsHeaderExplanations },
	methods: {
		...mapActionsShorthand({ getAllDirectoryApps }),
	},
	mounted() {
		this.getAllDirectoryApps({ page: 1 });
	},
};
</script>
<style scoped lang="scss">
.setting_ps {
	margin-bottom: 100px;
}
</style>
